<template>
    <div>
        <div class="main-container">
            <tl-header type="h1">
                <div>Work/Base Days </div>
            </tl-header>
            <div class="d-payroll__group">
                <div class="d-heading2 d-marginBottom d-flexbox"></div>
            </div>
            <div v-if="true">
                <div class="download-btn">
                    <div class="download-btn-container">
                        <img src="@/assets/download.svg" class="img" />
                        <span class="text" @click="downloadTemplate">Download Template</span>
                        <loading-animation v-show="showLoader"></loading-animation>
                    </div>
                </div>
                <div class="margintop-20">
                    <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
                </div>
            </div>
            <pop-up-message v-if="showSuccessBulkUploadMsg" :message="responseMsg" btnText="Back"
                @back="back"></pop-up-message>
            <div class="line"></div>
            <br />
            <br />
            <btn-grp class="btnGrp">
                <btn text="Cancel" type="secondary" @click="cancel" />
                <btn text="Next" type="primary" @click="next" />
            </btn-grp>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import * as constants from "@/apis/constants.js";
import { api_variables } from "@/apis/variables.js";
import axios from "axios";
import { S3 } from "aws-sdk";

export default {
    name: 'WorkBaseDays',
    data() {
        return {
            showLoader: false,
            showSuccessBulkUploadMsg: false,
            responseMsg: '',
            isLopsLocked: false,
            errmsg: "",
            toast: false,
            responseMsg: "",
            showEmpDetails: false,
            showSuccessBulkUploadMsg: false,
            uploadMethod: "manualUpload",
            auto_suggestions: false,
        }
    },

    computed: {
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID"
        }),

        ...mapState({
            payGroupsData: state => state.payroll.paygroups.payGroups,
            payrollMonth: state => state.payroll.runpayroll.payrollMonth,
            payrollYear: state => state.payroll.runpayroll.payrollYear
        }),
        le_id() {
            if (this.$route.params.entity_index)
                return this.getleid(this.$route.params.entity_index);
            else return this.getleid(0);
        }
    },

    methods: {

        ...mapActions({
            act_download_workdays_template: "payroll/lopsandrlops/downloadWorkBaseDayTemplates",
            uploadWorkBaseDayTemplate:
                "dashboard/payroll/utilities/uploadloprlop/uploadWorkBaseDayTemplate",
        }),

        async downloadTemplate() {
            try {
                let data = {
                    le_id: this.le_id,
                }
                console.log(data);
                let res = await this.act_download_workdays_template(data);
                console.log(res);
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },

        async onUploadTemplate(event) {
            let currentMonthEnum = this.payrollMonth.toLowerCase().substring(0, 3);
            let year = this.payrollYear;
            let formData = new FormData();
            formData.append("file", event);
            formData.append("le_id", this.le_id);
            formData.append(
                "year", year
            );
            formData.append("month", currentMonthEnum);
            this.$root._data.isSaving = true;
            try {
                let res = await this.uploadWorkBaseDayTemplate(formData);
                if (res.data.status) {
                    this.responseMsg = res.data.message ? res.data.message : "";
                    this.showSuccessBulkUploadMsg = true;
                }
                setTimeout(() => {
                    this.$root._data.isSaving = false;
                }, 500);
            } catch (err) {
                this.$root._data.isSaving = false;
                this.toast = true;
                this.errmsg = err;
            }
        },
        cancel() {
            this.$router.push({
                path: `/payroll/run/${this.$route.params.entity_index ? this.$route.params.entity_index : 0
                    }/lopsandrlops`
            });
        },

        next() {
            this.$router.push({
                path: `/payroll/run/${this.$route.params.entity_index ? this.$route.params.entity_index : 0
                    }/variableEarnings`,

            });
        },
        back() {
            this.toast = false;
            this.showSuccessBulkUploadMsg = false;
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.download-btn-container {
    display: flex;
    align-items: normal;

    .img {
        height: 18px;
        width: 16px;
        object-fit: contain;
    }

    .text {
        font-size: 14px;
        font-weight: 600;
        color: $color-secondary;
        margin-left: 8px;
        cursor: pointer;
    }
}

.paygrpsDiv {
    display: flex;
    cursor: pointer;
    padding: 40px 0px;

    span {
        color: #646464;
        font-size: 16px;
    }

    > :nth-child(n) {
        margin-right: 64px;
    }

    > :last-child {
        margin-right: 0px;
    }
}

.paygrps-info {
    color: #646464;
    cursor: pointer;
    text-align: center;
    margin-top: 5px;

    b {
        font-size: 24px;
        font-weight: 500;
    }
}

.paygrp {
    background: #fbfbfb;
    width: 31%;
    height: 85px;
    border-radius: 2px;
    border: solid 1px #37c6c0;
    padding: 20px;
    text-align: center;
    display: flex;
    justify-content: inherit;
}

.alignPaygrp {
    padding: 20px;
    text-align: center;
}

.d-marginBottom {
    margin-bottom: 7px;
}

// .line {
//   border-bottom: 1px solid #c8c8c8;
//   width: 100%;
//   margin-bottom: 20px;
// }
.uploadMethoRadio {
    margin-top: 30px;
    display: flex;
    margin-bottom: 2%;
}

.label {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 8px;
    color: #6e6e6e;
}

.download-btn {
    margin-top: 2%;
}

.search-result {
    position: absolute;
    width: 320px;
    background: #ffffff;
    max-height: 368px;
    border-radius: 4px;
    border: solid 1px #f7f7f7;
    overflow: auto;

    li {
        padding: 15px;
        border-bottom: 0.5px solid #e3e3e3;
        margin-right: 0px !important;

        &:hover {
            background-color: #d6f2f2;
        }
    }
}

.upload {
    display: flex;
    width: 30%;
    margin-top: 2%;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(to right,
            lightgray 10px,
            rgba(255, 255, 255, 0) 0%),
        linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
        linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
        linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
    background-position: top, right, bottom, left;
    background-repeat: repeat-x, repeat-y;
    background-size: 20px 1px, 1px 20px;
    height: 140px;
}

.upload-button {
    display: flex;
    align-items: center;

    label {
        cursor: pointer;
        border: 1px solid #5d409f;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 15px;
        margin-top: 2px;
        color: #5d409f;
    }

    #upload-photo {
        opacity: 0;
        position: absolute;
        z-index: -1;
    }

    img {
        height: 19px;
        width: 19px;
        margin-right: 8px;
    }
}

.fourColumnGrid {
    display: grid;
    grid-template-columns: 1fr 1fr 0fr 3fr;
    // grid-template-columns: 6fr 2fr 1fr 3fr;
    grid-gap: 20px;
}

.line {
    padding-top: 15%;
    border-bottom: 1px solid #34c0be;
    flex-grow: 1;
    margin-top: 15%;
}

.btnGrp {
    float: right;
}

.text {
    color: #37c6c0;
}

.search-bar {
    width: 100%;
    border: 1px solid #d6d4d4;
    border-radius: 3px;
    height: 30px;
    padding: 5px;
    outline: none;
    position: relative;
}

.search-icon {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 18px;
    height: 18px;
}

.search-container {
    position: relative;
    margin-top: 3px;
}

.noofdays {
    input {
        border-radius: 4px;
        border: 1px solid #dadada;
        padding: 10px;
        width: 100px;
        height: 35px;
        transition: ease-in-out, width 0.35s ease-in-out;

        &:focus {
            outline: none;
            border: 2px solid #34c0be;
        }
    }
}

.img-part {
    img {
        width: 100%;
    }
}

.typeClass {
    margin-left: 70px;
}

.dateCalClass {
    margin-top: 19px;
    margin-left: 15px;
}

.custom-txt {
    // width: 75px;
    margin-top: -1px;
    margin-left: 15px;
}

.filterbtn {
    width: 95px;
    height: 35px;
    border-radius: 4px;
    border: solid 1px #34c0be;
    color: #34c0be;
    cursor: pointer;
    margin-left: -15px;
    margin-bottom: 40px;
}

lock-list {
    span {
        margin-top: 20px;
    }
}

.margin-t-l-15 {
    margin-left: 0px;
}
</style>